// Demo profile data for the placeholder /profile page and friend-avatar matching
// (relocated from mockData.js — Phase 10F). This is sample user data, not event
// data; the real account profile lives at /account/profile (MyProfile).
//
// NOTE: bookingHistory / favoriteEvents / followingDJs hold sample ids that are
// enriched against the live backend where they resolve, and safely dropped when
// they don't (e.g. archived or non-existent events).

export const mockUser = {
  id: 'user_001',
  name: 'Arjun Patel',
  email: 'arjun.patel@email.com',
  avatar: 'https://images.unsplash.com/photo-1764014482589-14845f224990?crop=entropy&cs=srgb&fm=jpg&q=85',
  location: 'New York, NY',
  memberSince: 'Jan 2024',
  tier: 'Gold',
  stats: {
    eventsAttended: 24,
    following: 8,
    referrals: 3,
    points: 1240,
  },
  preferences: {
    genres: ['Bollywood', 'EDM', 'Punjabi'],
    cities: ['New York', 'Brooklyn', 'New Jersey'],
  },
  favoriteEvents: [],
  followingDJs: [],
  bookingHistory: [],
  friends: [
    { id: 'user_002', name: 'Priya S.', avatar: 'https://images.unsplash.com/photo-1654031424664-e0e6174fbd26?crop=entropy&cs=srgb&fm=jpg&q=85' },
    { id: 'user_003', name: 'Rahul M.', avatar: 'https://images.unsplash.com/photo-1764014482589-14845f224990?crop=entropy&cs=srgb&fm=jpg&q=85' },
    { id: 'user_004', name: 'Anita K.', avatar: 'https://images.unsplash.com/photo-1654031424664-e0e6174fbd26?crop=entropy&cs=srgb&fm=jpg&q=85' },
    { id: 'user_005', name: 'Manpreet D.', avatar: 'https://images.unsplash.com/photo-1764014482589-14845f224990?crop=entropy&cs=srgb&fm=jpg&q=85' },
  ],
  reminders: [],
};

export default mockUser;
